let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ezVq")).then(() => parcelRequire('2To7f'));